import { Component, OnInit } from '@angular/core';
import { DataService } from 'src/app/services/data.service';
import { environment } from 'src/environments/environment';

@Component({
  selector: 'app-conversations-list',
  templateUrl: './conversations-list.component.html',
  styleUrl: './conversations-list.component.css'
})

export class ConversationsListComponent implements OnInit {

  conversaciones: any;
  constructor(private dataService: DataService){

  }

  ngOnInit(){
    this.dataService.getData('conversaciones', environment.apiMensajeUrl).subscribe({
        next: (v) => this.conversaciones = v,
        error: (e) => console.error(e)
      }
    )
  }

  // Almacena la conversación seleccionada
  conversacionSeleccionada: any = null;

  seleccionarConversacion(conversacion: any) {
    this.conversacionSeleccionada = conversacion;
  }
}

